<template>
  <div class="shopIndex">
    <div class="w">
      <div class="classBox">
        <div class="classChocie">
          <el-button type="text" @click.stop="readAgreement" class="classBtn"
            >综合<i class="el-icon-sort-down"></i
          ></el-button>
          <el-button type="text" @click.stop="readAgreement" class="classBtn"
            >评论数<i class="el-icon-sort-down"></i
          ></el-button>
          <el-button type="text" @click.stop="readAgreement" class="classBtn"
            >数量<i class="el-icon-sort-down"></i
          ></el-button>
          <el-button type="text" @click.stop="readAgreement" class="classBtn"
            >新品<i class="el-icon-sort-down"></i
          ></el-button>
          <el-button type="text" @click.stop="readAgreement" class="classBtn"
            >价格<i class="el-icon-sort"></i
          ></el-button>
        </div>
        <div class="commodityNub">
          共 <span style="color: #2469f1">125</span> 个数据
        </div>
      </div>
      <div>
        <el-menu
          :default-active="activeName"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#409eff"
          @select="tabClick"
        >
          <el-menu-item index="1" v-for="(item,index) in ServiceCourseCenter" :key="index">
            {{item.plateName}}
          </el-menu-item>
        </el-menu>
      </div>
      <div>
        <shopList></shopList>
      </div>
    </div>
  </div>
</template>

<script>
import shopList from "@/components/RemoteSensingMall/shopList.vue";
export default {
  components: {
    shopList,
  },
  data() {
    return {
      activeName: "",
      ServiceCourseCenter:[]
    };
  },
  mounted() {
    // 获取商品板块分类
    this.initGoodsClass();
  },
  methods: {
    tabClick(e) {
      console.log(e);
    },
    // 协议跳转
    readAgreement() {
      console.log("打开协议页面");
    },
    initGoodsClass() {
      this.$http
        .get(this.$const.RemoteSensingMall.GoodsModuleClass, "")
        .then((res) => {
          console.log("获取商品板块分类:", res);
          if (res.code == 200) {
            this.ServiceCourseCenter = res.data;
          } else {
            this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          this.$message.error(this.$PubText.InterfaceFail);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 顶栏容器CSS END */
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}

.el-menu--horizontal > .el-menu-item {
  font-size: 22px;
  color: #333;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 3px solid #2469f1 !important;
  font-weight: 700;
  color: #2469f1 !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #2469f1 !important;
  border-bottom: 3px solid #2469f1 !important;
  font-weight: 700;
}
.commodityNub {
  width: 200px;
  font-size: 22px;
}
.classBtn :hover {
  color: #1890ff;
}
.classBtn {
  font-size: 22px;
  font-weight: 700;
  padding: 0 20px;
  color: #000;
}
.classChocie {
  display: flex;
  flex: 1;
  align-items: center;
}
.classBox {
  padding: 20px 0px;
  display: flex;
  align-items: center;
}
</style>